import { Injectable } from '@angular/core';

import { MatSnackBar } from '@angular/material';

import { AngularFireAuth } from 'angularfire2/auth';
import { AngularFireDatabase } from 'angularfire2/database';
import { AngularFireStorage } from 'angularfire2/storage';

import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { first, tap } from 'rxjs/operators';
import { Subscription } from 'rxjs/Subscription';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/operator/do';

import * as firebase from 'firebase/app';
import * as webNotification from 'simple-web-notification';

@Injectable()
export class GlobalService {

  global_loader: boolean;
  domain: any;
  root_path = 'dummy';

  selected_thread: any;
  current_user_profile: any;
  userId: any;

  search_users_subscription: Subscription;
  current_user_subscription: Subscription;
  user_thread_subscription: Subscription;
  master_thread_subscription: any = {};
  master_user_subscription: any = {};
  message_subscription: Subscription;
  other_user_subscription: Subscription;

  public addUsersDialog$ = new Subject<boolean>();

  individual_thread_list: any[] = [];

  is_verification_link_shown: boolean;

  constructor(
    public _fireAuth: AngularFireAuth,
    public _fireDB: AngularFireDatabase,
    public _fireStorage: AngularFireStorage,
    private _router: Router,
    public _snackBar: MatSnackBar
  ) {
    // console.log('global service');
    localStorage.removeItem('firebase:previous_websocket_failure');
    this.checkForLogin2();
  }

  resetGlobalVariable() {
    // this.domain = '' ;
    this.selected_thread = null;
    this.current_user_profile = null;
    this.userId = null;
    this.individual_thread_list = []
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 5000,
    });
  }

  getDomain(email) {
    const i1 = email.indexOf('@');
    const sub1 = email.substr(i1 + 1);
    const domain = sub1.substr(0, sub1.indexOf('.'));
    // console.log('domain', domain);
    return domain;
  }

  login(email, password) {
    return this._fireAuth.auth.signInWithEmailAndPassword(email, password);
  }

  signup(email, password) {
    return this._fireAuth.auth.createUserWithEmailAndPassword(email, password);
  }

  forgot(email) {
    return this._fireAuth.auth.sendPasswordResetEmail(email);
  }

  logout() {

    try {
      this.updateStatus(false);

      if (this.search_users_subscription) {
        this.search_users_subscription.unsubscribe();
      }
      if (this.current_user_subscription) {
        this.current_user_subscription.unsubscribe();
      }
      if (this.user_thread_subscription) {
        this.user_thread_subscription.unsubscribe();
      }
      if (this.message_subscription) {
        this.message_subscription.unsubscribe();
      }
      if (this.other_user_subscription) {
        this.other_user_subscription.unsubscribe();
      }
      for (const key in this.master_thread_subscription) {
        if (this.master_thread_subscription[key]) {
          this.master_thread_subscription[key].unsubscribe();
        }
      }
      for (const key in this.master_user_subscription) {
        if (this.master_user_subscription[key]) {
          this.master_user_subscription[key].unsubscribe();
        }
      }
    } catch (err) {
      // console.log('error catch');
      this._fireAuth.auth.signOut();
      // localStorage.clear();
    }

    this.resetGlobalVariable();

    this._fireAuth.auth.signOut();
    // localStorage.clear();
    this._router.navigate(['/login']);
  }

  checkForLogin2() {
    this._fireAuth.authState.do(user => {
      if (user) {
        // console.log('loggedd in', user);
        this.userId = user.uid;
        this.updateOnConnect();
        this.updateOnDisconnect();
        if (!user.emailVerified) {

        } else {
          this.getCurrentUserProfile();
        }
      } else {
        // console.log('noooooooooot loggedd in');
        // this._router.navigate(['']);
      }

    })
      .subscribe();
  }

  sendVerificationEmail() {
    firebase.auth().currentUser.sendEmailVerification().then(() => {
      this.global_loader = false;
      this.openSnackBar('Email sent', 'Dismiss');
    }).catch((err) => {
      this.global_loader = false;
      this.openSnackBar(err, 'Dismiss');
    });
  }

  /// Helper to perform the update in Firebase
  private updateStatus(status: boolean) {
    if (this._fireAuth.auth.currentUser.uid && this._fireAuth.auth.currentUser.emailVerified
      && this.domain && this.domain !== undefined) {
      this._fireDB.object(this.root_path + '/'
        + this.domain + '/users/' + this._fireAuth.auth.currentUser.uid).update({ online: status });
    } else {

    }

  }

  /// Updates status when connection to Firebase starts
  private updateOnConnect() {
    return this._fireDB.object('.info/connected').valueChanges()
      .do(connected => {
        // console.log('connected')
        const status = connected ? true : false;
        this.updateStatus(status);
      })
      .subscribe();
  }

  /// Updates status when connection to Firebase ends
  private updateOnDisconnect() {
    // console.log('update on disconnect');
    const presenceRef = firebase.database().ref().child(this.root_path + '/'
      + this.getDomain(this._fireAuth.auth.currentUser.email) + '/users/' + this._fireAuth.auth.currentUser.uid);

    if (this._fireAuth.auth.currentUser.emailVerified) {
      presenceRef.onDisconnect()
        .update({ online: false });
    }

  }

  getCurrentUserProfile() {
    this.domain = this.getDomain(this._fireAuth.auth.currentUser.email);

    if (this.current_user_subscription) {
      this.current_user_subscription.unsubscribe();
    }

    this.current_user_subscription = this._fireDB.object(this.root_path + '/'
      + this.getDomain(this._fireAuth.auth.currentUser.email) + '/users/' + this._fireAuth.auth.currentUser.uid)
      .valueChanges()
      .subscribe(response => {
        // console.log('current profile', response);

        this.current_user_profile = response;

        if (this.current_user_profile) {
          if (this.current_user_profile.authentication_id && this.current_user_profile.meta) {
            // localStorage.setItem('current_user_profile', JSON.stringify(this.current_user_profile));
            this._router.navigate(['/chat']);
          } else {
            this.onRegisterUnsavedUser();
          }
        } else {
          this.onRegisterUnsavedUser();
        }

      });

  }

  onRegisterUnsavedUser() {
    this.domain = this.getDomain(this._fireAuth.auth.currentUser.email);
    const userdata = {
      authentication_id: this._fireAuth.auth.currentUser.uid,
      meta: {
        email: this._fireAuth.auth.currentUser.email,
        name: this._fireAuth.auth.currentUser.displayName ?
          this._fireAuth.auth.currentUser.displayName : this._fireAuth.auth.currentUser.email,
        mobile: '',
        pictureURL: '',
        pictureURLThumbnail: '',
        orgid: this.domain
      },
      emailVerified: true,
      online: true,
      theme: null
    };

    const path = this.root_path + '/' +
      this.domain + '/users/' + userdata.authentication_id;

    this._fireDB.object(path).update(userdata)
      .then((resp) => {
        // console.log(resp);
        this.global_loader = false;
        this.current_user_profile = userdata;
        // localStorage.setItem('current_user_profile', JSON.stringify(this.current_user_profile));
        this._router.navigate(['/chat']);
        // this.consolLog(`new reg ${resp}`);
      })
      .catch((err) => {
        // console.log('error: ' + err);
        this.global_loader = false;
      });


    // searchIndex
    const searchdata = {
      email: this._fireAuth.auth.currentUser.email,
      name: this._fireAuth.auth.currentUser.displayName ?
        this._fireAuth.auth.currentUser.displayName : this._fireAuth.auth.currentUser.email,
      orgid: this.domain
    };
    const datasave = {};
    datasave[this.root_path + '/' +
      this.domain + '/searchIndex/' + userdata.authentication_id] = searchdata;
    this.firebaseUpdate(datasave);
    // end search index

  }

  getThreadList() {

  }

  updateUnseenCount(thread_id, user_id, count) {
    const unseen_count_path: any = this.root_path + '/' +
      this.domain + '/users/' + user_id +
      '/threads/' + thread_id + '/unseenCount';
    const datasave = {};
    datasave[unseen_count_path] = count;
    // console.log('update unseen count ', datasave);
    this.firebaseUpdate(datasave);
  }

  firebaseUpdate(datasave) {

    return this._fireDB.database.ref().update(datasave);

  }

  webNotification(subject, body, iconThumnail) {
    webNotification.showNotification(subject, {
      body: body,
      icon: iconThumnail,
      onClick: function onNotificationClicked() {
        // console.log('Notification clicked.');
      },
      autoClose: 4000
    }, function onShow(error, hide) {
      if (error) {
        // window.alert('Unable to show notification: ' + error.message);
      } else {
        // console.log('Notification Shown.');
        setTimeout(function hideNotification() {
          // console.log('Hiding notification....');
          hide();
        }, 6000);
      }
    });
  }

  consolLog(data) {
    // console.log('console ', data);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/global.service.ts